<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item v-for="(item, index) in breadcrumbArray" :key="index">{{item}}</el-breadcrumb-item>
  </el-breadcrumb>

</template>

<script>

export default {
  name: 'breadcrumb',

  components:{},

  props:{
    breadcrumbArray: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
    }
  },

  methods: {},

  computed: {},

  created() {},

  mounted() {},
}
</script>
